module.exports = __webpack_public_path__ + "icomoon.cd08942279b9462256c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/fonts/icomoon.svg?dtob5z
// module id = 564
// module chunks = 15